/***
 * 单选接口获取数据
 */

import React from 'react';
import { getData } from '@util';
import { Select } from 'antd';
import { ASKPRICEMANAGMENT_GET_CITY } from '@api';
class DeliverableCity extends React.PureComponent {
  state = {
    AddCodeData: [],
  };

  componentDidMount() {
    this.getAddCodeFunc();
  }

  getAddCodeFunc = () => {
    getData({
      api: ASKPRICEMANAGMENT_GET_CITY,
    }).then(res => {
      const { result } = res;
      this.setState({
        AddCodeData: [...result],
      });
    });
  };

  render() {
    const { AddCodeData } = this.state;
    const { renderValue } = this.props;
    return (
      <Select
        mode="multiple"
        tokenSeparators={[' ']}
        optionFilterProp="children"
        allowClear
        showSearch
        placeholder={'请选择'}
        {...this.props}>
        {AddCodeData.map(item => (
          <Select.Option
            key={item.cityCode}
            value={renderValue ? renderValue(item) : `${item.cityCode}`}>
            {item.cityName}
          </Select.Option>
        ))}
      </Select>
    );
  }
}

export default DeliverableCity;
